'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flow = require('./flow.html');

var _flow2 = _interopRequireDefault(_flow);

var _flow3 = require('./flow.controller');

var _flow4 = _interopRequireDefault(_flow3);

require('./flow.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flowComponent = {
  restrict: 'E',
  bindings: {},
  template: _flow2.default,
  controller: _flow4.default,
  controllerAs: 'vm'
};

exports.default = flowComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/flow/flow.component.js
 **/